import { useState, useEffect } from 'react';

// Subscribes to a CSS media query and returns whether it currently matches.
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

// Matches the SCSS `mobile` mixin breakpoint (max-width: 768px).
export function useIsMobile() {
  return useMediaQuery('(max-width: 768px)');
}
